import { Component, Input  } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ChangeCallback } from '@core/components/abstract-field.component';
import { CountryOptionsService, ICountryOption } from '@core/components/country-select/country-options.service';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',

  // This part is reponsible for the integration of the input inside the angular forms
  // It allows angular formControl element to communicate with our custom input
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CountrySelectComponent,
    multi: true
  }]
})
export class CountrySelectComponent {
  @Input() public disabled: boolean;
  @Input() public required: boolean;

  public selected: string;
  public onChangeCb: ChangeCallback;
  public countryOrderedOptions: ICountryOption[];

  constructor(private readonly countryOptionsService: CountryOptionsService) {
    this.countryOrderedOptions = this.countryOptionsService.getOrderedOptions();
  }

  // These 3 functions are part of the NG_VALUE_ACCESSOR
  // they must be implemented for Angular to access our input
  public writeValue(value: string | undefined): void {
    // This function is called by Angular when the formControl element has its value updated
    if (value) {
      this.selected = `${value}`.toUpperCase();
    } else {
      this.selected = value;
    }
  }

  public registerOnChange(fn: ChangeCallback): void {
    // This function is used by Angular to listen to the update of our custom control
    this.onChangeCb = fn;
  }

  public registerOnTouched(): void {
    // This function is used by Angular to know if our element has been touched by the user
  }

}
